import VueI18n from 'vue-i18n';

/* istanbul ignore next */
const fallbackLocale = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en_US';

/**
 * Initialize the Vue-i18n plugin. Called from main.js.
 * @param {*} vue Vue instance
 * @param {String} locale the locale to use
 * @param {*} options options
 * @return {*} vue-i18n instance
 */
export function initI18n(vue, locale, options = {}) {
    vue.use(VueI18n);
    return new VueI18n(Object.assign({
        locale,
        fallbackLocale: fallbackLocale
    }, options));
}
